import { useSubscription } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import { useLatest } from 'react-use';

import { LlmOutputTypesEnum } from '@eluve/graphql-types';

import { useAppointmentContext } from './appointment.context';
import { listenForAppointmentLlmOutputsSubscription } from './insights.operations';

export const useListenForAppointmentLlmJobs = ({
  outputType,
  lastJobCompletedAt,
  onDataReceived,
}: {
  outputType: LlmOutputTypesEnum;
  lastJobCompletedAt: string | null;
  onDataReceived: () => void;
}) => {
  const { tenantId, appointmentId } = useAppointmentContext();

  const initialValue = useMemo(
    () => lastJobCompletedAt ?? new Date().toISOString(),
    [lastJobCompletedAt],
  );

  const { data } = useSubscription(listenForAppointmentLlmOutputsSubscription, {
    variables: {
      tenantId,
      appointmentId,
      outputType,
      initialValue,
    },
  });

  // Keyed on the job rather than called during render: a callback that sets
  // state would otherwise re-render this component, hit this line again, and
  // loop for as long as the subscription holds a job.
  const jobId = data?.appointmentLlmJobsStream[0]?.jobId ?? null;
  const latestOnDataReceived = useLatest(onDataReceived);

  useEffect(() => {
    if (jobId) {
      latestOnDataReceived.current();
    }
  }, [jobId, latestOnDataReceived]);
};
